/* eslint-disable camelcase */
/*
 * @Author: zhoulang zhoulang@kuaishou.com
 * @Date: 2024-04-25 19:45:49
 * @LastEditors: zhoulang zhoulang@kuaishou.com
 * @LastEditTime: 2024-04-28 17:50:53
 * @FilePath: /kibt-fe-shop-c-krn/src/common/utils/recoLog.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { getPageProps } from '@kibt/krn-utils';
import { radar } from '../log';
// TODO: 直播间猜喜、商详页pv待补充
export const validateP0Log = ({ action, params }) => {
    try {
        const bundleId = getPageProps().bundleId;
        const sendLog = () => {
            radar.event({
                name: action,
                eventType: 'CUSTOM_PO_LOG',
                params: { ...params, action },
            });
        };
        // 大卡商品卡点击和曝光 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1155148&fromPage=groupManage&groupId=8351&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['PRODUCT_CARD'].includes(action) && bundleId === 'EcommCommerce') {
            const { media_source, media_id, item_id } = params;
            // 增加非空检验
            if (!media_source || !media_id || !item_id) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 购物车猜喜的商品卡片曝光埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1131512&fromPage=groupManage&groupId=8351&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['ECO_PRODUCT_CARD'].includes(action) && bundleId === 'MyShoppingCar') {
            const { product_id, media_source, media_id, llsid } = params;
            // 增加非空检验
            if (!product_id || !media_source || !media_id || !llsid) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 商品评价成功页猜喜的商品卡曝光埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1151668&fromPage=groupManage&groupId=8351&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['ECO_PRODUCT_CARD'].includes(action) && bundleId === 'EcommAddComment') {
            const { item_id, media_source, media_id, llsid } = params;
            // 增加非空检验
            if (!item_id || !media_source || !media_id || !llsid) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 订单详情页猜喜的商品卡片曝光埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1131511&fromPage=groupManage&groupId=8351&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['ECO_PRODUCT_CARD'].includes(action) && bundleId === 'OrderDetail') {
            const { product_id, media_source, media_id, llsid, exptag } = params;
            // 增加非空检验
            if (!product_id || !media_source || !media_id || !llsid || !exptag) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 商详页店铺推荐模块的商品卡曝光埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1124367&fromPage=groupManage&groupId=8351&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['SHOP_RECOMMEND_CARD'].includes(action) && bundleId === 'Detail') {
            const { product_id, media_source, media_id, llsid, exptag } = params;
            // 增加非空检验
            if (!product_id || !media_source || !media_id || !llsid || !exptag) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 短视频双列主卡的加购点击埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1130450&fromPage=groupManage&groupId=8350&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['ADD_TO_CART'].includes(action) && bundleId === 'EcomRecommendGoods') {
            const { media_id } = params;
            // 增加非空检验
            if (!media_id) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 商详页加购按钮的点击埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1130441&fromPage=groupManage&groupId=8350&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['ADD_TO_CART'].includes(action) && bundleId === 'Detail') {
            const { item_id } = params;
            // 增加非空检验
            if (!item_id) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 订单详情加购点击埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1133080&fromPage=groupManage&groupId=8350&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['ADD_TO_CART'].includes(action) && bundleId === 'OrderDetail') {
            // 上报流量埋点
            sendLog();
        }
        // 商品详情页的购买点击埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1123592&fromPage=groupManage&groupId=8350&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['BUY_NOW'].includes(action) && bundleId === 'Detail') {
            const { produtc_id } = params;
            // 增加非空检验
            if (!produtc_id) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
        // 短视频双列购买点击埋点 https://data-track-sgp.corp.kuaishou.com/v3/#/entity/detail?entityCombineId=1128957&fromPage=groupManage&groupId=8350&submitDevPageType=ENTITY_NORMAL_EVENT&appName=TRINITY
        if (['BUY_NOW'].includes(action) && bundleId === 'EcomRecommendGoods') {
            const { item_id, photo_id, media_id } = params;
            // 增加非空检验
            if (!item_id || !photo_id || !media_id) {
                radar.event({
                    name: action,
                    eventType: 'CUSTOM_PO_LOG_PARAMS_ERROR',
                    params: { ...params, action },
                });
            }
            // 上报流量埋点
            sendLog();
        }
    } catch (error) {
        radar.event({
            name: action,
            eventType: 'CUSTOM_PO_LOG_FAIL',
            params: { ...params, action },
        });
    }
};
